import React from "react";
import ffairPrimaryBlackType from "./ffair-primary-black-type.svg";
import ffairPrimaryGrey from "./ffair-primary-grey.svg";
import ffairPrimaryIconBlue from "./ffair-primary-icon-blue.svg";
import ffairPrimaryIconGrey from "./ffair-primary-icon-grey.svg";

interface Props {
  className?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
}

const LogoImage = ({
  src,
  width,
  height,
  className,
  alt = "FFAIR logo",
}: Props & {src: string}) => (
  <img
    src={src}
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);

export const FFairPrimaryIconBlueLogo = ({
  width = 32,
  height = 32,
  className,
  alt,
}: Props) => (
  <LogoImage
    src={ffairPrimaryIconBlue}
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);

export const FFairPrimaryIconGreyLogo = ({
  width = 32,
  height = 32,
  className,
  alt,
}: Props) => (
  <LogoImage
    src={ffairPrimaryIconGrey}
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);

export const FFairPrimaryGreyLogo = ({
  width = 82,
  height = 40,
  className,
  alt,
}: Props) => (
  <LogoImage
    src={ffairPrimaryGrey}
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);

export const FFairPrimaryBlackTypeLogo = ({
  width = 82,
  height = 40,
  className,
  alt,
}: Props) => (
  <LogoImage
    src={ffairPrimaryBlackType}
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);

const FFairLogo = ({width = 32, height = 32, className, alt}: Props) => (
  <FFairPrimaryIconBlueLogo
    width={width}
    height={height}
    className={className}
    alt={alt}
  />
);
FFairLogo.defaultProps = {
  className: undefined,
};

export default FFairLogo;
